import { MasonryEngineNodeAction } from '@leagueplatform/masonry-engine';

/**
 * Adds data to the analytics payload of a MasonryEngineNodeAction
 * (if the action has analytics) and returns the modified action.
 */
export const addToActionAnalytics = (
  action: MasonryEngineNodeAction,
  data: Record<string, unknown>,
) =>
  action.analytics
    ? {
        ...action,
        analytics: {
          ...action.analytics,
          payload: {
            ...action.analytics.payload,
            ...data,
          },
        },
      }
    : action;
